$(document).ready(function() {

  $(function () {
    $('.postcard-send-wrap #popup__toggle').click(function(){
      // $.magnificPopup.open({
      //   items: {
      //     src: '#popup__toggle1' 
      //   },
      //   type: 'inline'
      // });
      $('.Bg_dark,.Main_hide' ).addClass('show_popup');
    });

	$(document).on('click', '.popup-dismiss', function (e) {
		e.preventDefault();
		// $.magnificPopup.close();
        $('.Bg_dark,.Main_hide' ).removeClass('show_popup');
     
	});
});
  if ($('.article-feture .row').is(':empty')) { 
  
  $('.article-feture').addClass('empty_row');
  };
  
 // Add <span> for blogpost  for animation
   $('.post-big-contnet').find('h2 .article-title').text().split('').forEach(function(c){
    //console.log(c);
    $('.post-big-contnet h2 .article-title').css("display","none");
    $('.post-big-contnet').find('h2').append("<span>"+c+"</span>");
  });
  
   $('.post-hor-content').find('h2 .article-title').text().split('').forEach(function(c){
    $('.post-hor-content h2 .article-title').css("display","none");
    $('.post-hor-content').find('h2').append("<span>"+c+"</span>");
   });
  
  
   setTimeout(function(){ 
     $('.needsclick img').click(function(){
   
   $('#clearpay-popup-wrapper').css("display","block");
   });
     
   },12000);
  
   
   
   $('.close_clearpay').click(function(){
   
   $('#clearpay-popup-wrapper').css("display","none");
   });




});

// document.addEventListener("DOMContentLoaded", function(event) {
//      $(".klaviyo_submit").click(function(){
//     var _learnq = _learnq || [];
//  _learnq.push(['track', 'Send Postcard from website', {
//    'to_email':"juno.gogle"
//   //  'to_email': $('#postcard_email').val(), 
//   //  'to_name':$('#postcard_to_name').val() + " " + $('#postcard_to_last_name').val(),
//   //   'from_email': $('#postcard_from_email').val(), 
//   //   'from_name': $('#postcard_img_from_first_name').val(),
//   //   'from_first_name': $('#postcard_img_from_last_name').val(), 
//   //   'image_url': $('#postcard_img').val(),
//   //   'caption': $('.postcard-section .postcard-content-title-caption p').text(), 
//   //   'message': $('#postcard_msg').val(),
//   //   'first_name_upper':$('#postcard_to_name').val().toUpperCase(), 
//   //  'from_name_upper' :$('#postcard_img_from_first_name').val().toUpperCase() + " " + $('#postcard_img_from_last_name').val().toUpperCase(),
//   // 'postcard_number': $('.postcard-content-number').text().replace('\n< Nº ','').replace(' >\n',''),
//   //  'first_name': $('#postcard_to_name').val(), 
//   //  'title':  $('#postcard_title').val(),
//   //   'from_first_name_upper':$('#postcard_img_from_first_name').val().toUpperCase()
//   }]);

       
//   //console.log($('#postcard_email').val() +'\n' + $('#postcard_to_name').val() +'\n'+ $('#postcard_to_last_name').val()+ '\n'+ $('#postcard_from_email').val() +'\n'+ $('#postcard_img_from_first_name').val() +'\n'+ $('#postcard_img_from_last_name').val() +'\n'+ $('#postcard_img').val() +'\n'+ $('.postcard-section .postcard-content-title-caption p').text()  +'\n'+  $('#postcard_msg').val()  +'\n'+ $('#postcard_to_name').val().toUpperCase() +'\n'+ $('#postcard_img_from_first_name').val().toUpperCase() + " " + $('#postcard_img_from_last_name').val().toUpperCase() +'\n'+  $('.postcard-content-number').text().replace('\n< Nº ','').replace(' >\n','')  +'\n'+  $('#postcard_to_name').val() +'\n'+ $('#postcard_title').val() +'\n'+ $('#postcard_img_from_last_name').val().toUpperCase());

       
// });
//   });

